import { BerserkEffect } from './berserk_effect'

export default {
    events: {},
    effects: {
        BerserkEffect
    },
    requirements: {}
}
